import { createContext } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/context/context-key.js';
export const loginServiceContext = createContext('mycigna-auth');
//# sourceMappingURL=interfaces.js.map